import {useIntl} from 'react-intl'
import useGlobalFields from './useGlobalFields'

export default function useNewsletterFields({form, prefix = ''}) {
    const {formatMessage} = useIntl()

    const emailPlaceholder = formatMessage({
        defaultMessage: 'Enter your email address',
        id: 'newsletter_banner.text.email_field_placeholder'
    })

    const {firstName, lastName, email} = useGlobalFields({
        form,
        prefix
    })

    return {
        emailWithButton: {...email, id: 'newsletter-email', placeholder: emailPlaceholder},
        firstName: {...firstName, rules: {maxLength: firstName.rules.maxLength}},
        lastName: {...lastName, rules: {maxLength: lastName.rules.maxLength}}
    }
}
